import { Suspense, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { Collapse, Stack } from "@mui/material";

import { observer, useStore } from "../../../service/mobx";
import Balance from "./Balance";

const Invoices = dynamic(() => import("./Invoices"));
const Usage = dynamic(() => import("./Usage"));

function Credits() {
  const [invoices, setInvoices] = useState([]);
  const [usage, setUsage] = useState([]);
  const { user } = useStore();

  useEffect(() => {
    if (user.loggedIn) {
      const cleanUp = [
        user.data.query(
          { collection: "grants", limit: 100, orderBy: [["created", "desc"]] },
          ({ docs }) => {
            const invoices = [];

            for (const doc of docs) {
              const invoice = { id: doc.id, ...doc.data() };

              invoices.push(invoice);
            }

            setInvoices(invoices);
          }
        ),
        user.data.query(
          {
            collection: "usage",
            where: [
              // the last 28 days
              ["start", ">=", new Date(Date.now() - 28 * 24 * 60 * 60 * 1000)]
            ],
            orderBy: [["start", "desc"]]
          },
          ({ docs }) => {
            const date = new Intl.DateTimeFormat(navigator.language, {
              year: "2-digit",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit"
            });
            const usage = [];

            for (const doc of docs) {
              const data = doc.data();
              const modelNameArray = data.model?.split("/") ?? [];
              const org = modelNameArray.shift();
              const tokens = data.tokens;
              const request = {
                id: doc.id,
                ...data,
                modelName: modelNameArray.join("/"),
                provider: org[0].toUpperCase() + org.slice(1),
                date: date.format(data.start.toDate?.()),
                tokens:
                  (tokens?.input ?? 0) +
                  (tokens?.output ?? 0) +
                  (tokens?.reasoning ?? 0)
              };

              usage.push(request);
            }

            setUsage(usage);
          }
        )
      ];

      return () => {
        setUsage([]);
        setInvoices([]);
        cleanUp.forEach(unsubscribe => unsubscribe());
      };
    }
  }, [user, user.loggedIn]);

  return (
    <Stack spacing={2}>
      <Balance />
      <Suspense>
        <Collapse mountOnEnter unmountOnExit in={invoices.length !== 0}>
          <Invoices invoices={invoices} />
        </Collapse>
      </Suspense>
      <Suspense>
        <Collapse mountOnEnter unmountOnExit in={usage.length !== 0}>
          <Usage usage={usage} />
        </Collapse>
      </Suspense>
    </Stack>
  );
}

export default observer(Credits);
